import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { ThunderboltTwoTone } from '@ant-design/icons';
import { Card, Popover, Row, Space, Divider, Radio, Col } from 'antd';
import TaskAssignToUserButton from 'components/TaskAssignToUserButton';
import TaskAssignToMeButton from 'components/TaskAssignToMeButton';
import TaskUpdateStatusButton from 'components/TaskUpdateStatusButton';
import TaskModal from '../../workflow/TaskModal';
import ModalController from 'components/ModalController';
import {
  GetMyTasks,
  GetMyTasksParams,
  ViewProcTaskResponse,
} from 'services/workflow';
import AntButton from 'components/Button';
import DF from 'DisplayFramework';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import RouterLink from 'components/RouterLink';
import PopoverController from 'components/PopoverController';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import Checkbox from 'components/Checkbox';
import GetLabel from 'DisplayFramework/components/GetLabel';
import _ from 'lodash';

const getUrl = (procmodule: string, id: number) => {
  if (procmodule === 'SINVOICE') {
    return `/supplier-invoice/${id}`;
  } else if (procmodule === 'PROPOSAL') {
    return `/proposal/${id}`;
  } else if (procmodule === 'CINVOICE') {
    return `/clientinvoice/${id}`;
  } else if (procmodule === 'THIRDPARTY') {
    return `/third-party/${id}/TP`;
  }else if (procmodule === 'COLLECTION') {
    return `/collection/${id}`;
  }
  return undefined;
};

export type TasksTableProps = {
  title?: string;
  height?: number;
  isFromLink?: boolean;
  taskTable?: ViewProcTaskResponse[];
};

const MyTasksTable = (props: TasksTableProps) => {
  const { title, height, isFromLink, taskTable } = props;
  const { getComponentLabel } = useDisplayFrameworkContext();
  
  const [searchParam, setSearchParam] = useState<GetMyTasksParams>({
    entity: '',
    entityid: 0,
    taskstatus: 'INIT',
    taskid: 0,
    proccode: '',
    flagsender: false,
    flagreceiver: true,
    flagholder: false,
  });

  const { data, refetch, isFetching } = useQuery(
    ['GetMyTasks', searchParam],
    () => GetMyTasks(searchParam).then((res) => res.list || []),
    { enabled: !isFromLink }
  );

  const dataTable = taskTable ?? data;

  const columns: DataGridColDef<any>[] = [
    {
      dataIndex: 'modulename',
      comcode: 'taskTable.modulename',
      render: (modulename, record) => (
        <RouterLink to={getUrl(record.procmodule, record.objectid)}>
          {modulename}
        </RouterLink>
      ),
      width: 100,
    },
    {
      dataIndex: 'objectreference',
      comcode: 'taskTable.objectreference',
      render: (objectreference, record) => (
        <RouterLink to={getUrl(record.procmodule, record.objectid)}>
          {objectreference}
        </RouterLink>
      ),
      width: 100,
    },
    {
      // @todo open executeTask in modal
      dataIndex: 'tasklabel',
      comcode: 'taskTable.tasklabel',
      width: 200,
      render: (tasklabel, record) => (
        <ModalController>
          {({ setVisible, visible }) => (
            <>
              <a onClick={() => setVisible(true)}>{tasklabel}</a>

              <TaskModal
                random={Math.round(_.random(100000) * 10000000)}
                entityId={record.objectid}
                entity={record.procmodule}
                entityName={record.procmodule}
                entityReference={record.objectreference}
                subentity={record.subentity}
                subentityid={record.subentityid}
                task={{
                  taskid: record.taskid,
                  tasklabel:
                    record.modulename +
                    ' ' +
                    record.objectreference +
                    ' - ' +
                    tasklabel,
                  funcode: record.funcode,
                  id: record.proctaskid,
                  lancode: '',
                  proccode: record.proccode,
                  procmodule: record.procmodule,
                  procrule: '',
                  serviceurl: record.serviceurl,
                  taskrule: '',
                  tasktriggermode: '',
                  tasktype: '',
                  subentity: record.subentity,
                  subentityid: record.subentityid,
                }}
                visible={visible}
                onCancel={() => {
                  setVisible(false);
                  refetch();
                }}
                onSuccess={() => {
                  // setVisible(false);
                  refetch();
                }}
              />
            </>
          )}
        </ModalController>
      ),
    },
    {
      comcode: 'taskTable.sendername',
      dataIndex: 'sendername',
      width: 200,
    },
    {
      comcode: 'taskTable.holdername',
      dataIndex: 'holdername',
      width: 200,
    },
    {
      comcode: 'taskTable.receivername',
      dataIndex: 'receivername',
      width: 200,
      align: 'right',
    },
    {
      comcode: 'taskTable.startdate',
      dataIndex: 'startdate',
      align: 'right',
      width: 100,
    },
    {
      comcode: 'taskTable.statusdate',
      dataIndex: 'taskstatusdate',
      align: 'right',

      width: 100,
    },
    {
      comcode: 'taskTable.statuslabel',
      dataIndex: 'taskstatuslabel',
    

      width: 100,
    },
    {
      key: 'action',
      comcode: 'action',
      width: 100,
      render: (record) => (
        <PopoverController>
          {({ setVisible, visible }) => (
            <Popover
              placement="bottomRight"
              visible={visible}
              trigger="click"
              onVisibleChange={setVisible}
              content={
                <Space
                  direction="vertical"
                  size={10}
                  style={{ width: '220px' }}
                >
                  <Row gutter={[8, 0]}>
                    <TaskAssignToUserButton
                      proctaskid={record.proctaskid}
                      label={getComponentLabel('assign')}
                      refetch={refetch}
                    ></TaskAssignToUserButton>

                    <Divider>Or</Divider>
                  </Row>

                 
                    <Row >
                     <div style={{margin:"auto"}}>
                      <TaskAssignToMeButton
                        proctaskidList={[{ proctaskid: record.proctaskid }]}
                        refetch={refetch}
                        label={getComponentLabel('getIt')}
                        style={{width:"200px", alignItems:"center"}}

                      ></TaskAssignToMeButton>
                      </div>
                    
                    
                  </Row>
                  <Row gutter={[0, 8]}>
                   
                   
                   <div style={{ margin:"auto"}}>
                     <TaskUpdateStatusButton
                       proctaskid={record.proctaskid}
                       status={
                         record.taskstatus === 'INIT' ? 'CLOSED' : 'INIT'
                       }
                       refetch={refetch}
                       style={{width:"200px", alignItems:"center"}}
                     ></TaskUpdateStatusButton>
                     </div>
                     </Row>
                </Space>
              }
            >
              <AntButton
                comcode="action"
                icon={<ThunderboltTwoTone twoToneColor="#eb2f96" />}
                size="small"
                onClick={() => setVisible(true)}
                style={{ width: '100%', height: 30 }}
              />
            </Popover>
          )}
        </PopoverController>
      ),
    },
  ];

  return (
    <DF.Provider pagcode="welcome">
      <Card  className='ut-card-list' title={title} size="small" type="inner" style={{ height: height }}>
        <Row justify="space-between">
          <Col>
            <Checkbox
              comcode="flagsender"
              onChange={(e) => {
                setSearchParam({
                  ...searchParam,
                  flagsender: e.target.checked ? true : false,
                });
              }}
            />
            <Checkbox
              defaultChecked
              comcode="flagreceiver"
              onChange={(e) => {
                setSearchParam({
                  ...searchParam,
                  flagreceiver: e.target.checked ? true : false,
                });
              }}
            />
            <Checkbox
              comcode="flagholder"
              onChange={(e) => {
                setSearchParam({
                  ...searchParam,
                  flagholder: e.target.checked ? true : false,
                });
              }}
            />
          </Col>
          <Col>
            <Radio.Group
              defaultValue="INIT"
              onChange={(e) => {
                setSearchParam({
                  ...searchParam,
                  taskstatus: e.target.value,
                });
              }}
            >
              <Radio value="INIT">
                <GetLabel label="INIT" />
              </Radio>
              <Radio value="ASSIGNED">
                <GetLabel label="ASSIGNED" />
              </Radio>
              <Radio value="CLOSED">
                <GetLabel label="CLOSED" />
              </Radio>
            </Radio.Group>
          </Col>
        </Row>

        
          <DataGrid 
            rowKey={(record) => record.proctaskid}
            dataSource={dataTable}
            columns={columns}
            isLoading={isFetching}
          />
     
        
      </Card>
    </DF.Provider>
  );
};

export default MyTasksTable;
